export default "__VITE_ASSET__B3l$DZg___"